import React, { Component } from "react";
import { LinkContainer } from "react-router-bootstrap";


export default class Home extends Component {
    constructor(props) {
        super(props);

        
        this.state = {
            
        };


    }

    
    componentWillUnmount() {       
        
    }

    async componentDidMount() {
        this.props.handleAppReset();
          }

    render() {
        return (
            <div className="Home"></div>
        );
    }
}